import { render, staticRenderFns } from "./Jurisdictions.vue?vue&type=template&id=67cdbb56"
import script from "./Jurisdictions.vue?vue&type=script&lang=js"
export * from "./Jurisdictions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports